// extracted by mini-css-extract-plugin
module.exports = {"container":"historyDropDown_container__26uZD","current-option":"historyDropDown_current-option__I1y6L","dropdown-menu":"historyDropDown_dropdown-menu__XGSCh"};